
import React, {Component} from 'react'
import { IoNotificationsOutline } from "react-icons/io5";

var dateUtil = require('../../../utils/dateUtil/dateUtil');
var storefrontUtility = require('../../../utils/domain/storefrontUtility');
var formatter = require('../../../utils/formatter/formatter.js');
var flipdishManualSaleAcceptanceTimeCalculator = require('../../../utils/domain/sales/flipdishManualSaleAcceptanceTimeCalculator');
var saleCalculator = require('../../../utils/domain/sales/saleCalculator');
var translator = require('../../../utils/translator/translator');

class ManualOrderAcceptanceCard extends Component 
{
    render()
    {
        var sale = this.props.notification.payload;
        var storefront = storefrontUtility.getStorefrontById(sale.storefrontId);
        
        return <div style={{border:'1px solid #686868'}}>
                    <table width="100%">
                        <tr>
                            <td align="center">
                                <div style={{paddingTop:'5px', paddingBottom:'5px', background:'var(--colors-primary)', color:'var(--colors-white)'}}>
                                    <table>
                                        <tr>
                                            <td>
                                                <IoNotificationsOutline size={28}/>
                                            </td>
                                            <td>
                                                <div style={{marginTop:'0px', marginLeft:'5px', fontSize:'1.5rem'}}>{translator.getLabel("new_order")}</div>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </td>
                        </tr>


                        <tr>
                            <td>
                                <div style={{marginLeft:'10px', marginRight:'10px', marginTop:'10px', marginBottom:'10px'}}>
                                    <table width="100%">
                                        <tr>
                                            <td style={{width:'99%', textAlign:'start'}}>
                                            {translator.getLabel("order_number")}
                                            </td>
                                            <td style={{textAlign:'right', whiteSpace:'nowrap'}}>
                                                {sale.number}
                                            </td>
                                        </tr>

                                        <tr>
                                            <td style={{width:'99%', textAlign:'start'}}>
                                            {translator.getLabel("sale_time")}
                                            </td>
                                            <td style={{textAlign:'right', whiteSpace:'nowrap'}}>
                                                {dateUtil.formatDate(sale.dateTime, "HH:mm")}
                                            </td>
                                        </tr>

                                        <tr>
                                            <td style={{width:'99%', textAlign:'start'}}>
                                            {translator.getLabel("storefront")}
                                            </td>
                                            <td style={{textAlign:'right', whiteSpace:'nowrap'}}>
                                                {storefront.name}
                                            </td>
                                        </tr>

                                        <tr>
                                            <td style={{width:'99%', textAlign:'start'}}>
                                            {translator.getLabel("dispatch")}
                                            </td>
                                            <td style={{textAlign:'right', whiteSpace:'nowrap'}}>
                                                {sale.dispatchType}
                                            </td>
                                        </tr>

                                        <tr>
                                            <td style={{width:'99%', textAlign:'start'}}>
                                            {translator.getLabel("sale_price")}
                                            </td>
                                            <td style={{textAlign:'right', whiteSpace:'nowrap'}}>
                                                {formatter.convertToCurrencyFormat(saleCalculator.calculateTotalSalePrice(sale))}
                                            </td>
                                        </tr>

                                        <tr>
                                            <td style={{width:'99%', textAlign:'start'}}>
                                            {translator.getLabel("expected_time")}
                                            </td>
                                            <td style={{width:'1%', whiteSpace:'nowrap', textAlign:'end'}}>
                                                {flipdishManualSaleAcceptanceTimeCalculator.getFormattedDateTimeToLocalTime(flipdishManualSaleAcceptanceTimeCalculator.getExpectedHandoverTime(sale))}
                                            </td>
                                        </tr>

                                        <tr>
                                            <td style={{width:'99%', textAlign:'start'}}>
                                            {translator.getLabel("payment_status")}
                                            </td>
                                            <td style={{width:'1%', whiteSpace:'nowrap', textAlign:'end'}}>
                                                {saleCalculator.isSaleFullyPaid(sale) ? "Paid" : "NOT Paid"}
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </td>
                        </tr>
                </table>

                <div style={{textAlign:'end', fontSize:'0.8rem', color:'var(--colors-text-light)', marginRight:'10px'}}>
                        {dateUtil.formatDate(sale.dateTime, "ddd DD MMM, HH:mm")}
                </div>
            </div>
    }
}

export default ManualOrderAcceptanceCard